<template>
	<div>
		<el-dialog :title="form.title" :visible.sync="formOpen" :width="!$store.state.isphone?'800px':($store.state.width-12+'px')" :before-close="formClose">
			<div v-loading="$store.state.formload">
				<el-form :model="EAform" :rules="EArules" ref="EAform" :label-width="!$store.state.isphone?'110px':''">
					<div v-for="(item,index) in fields" :key="index">
						<el-form-item :label="item.label" :prop="item.name" v-if="(form.title=='添加'&&item.limits.add)||(form.title=='编辑'&&item.limits.edit)">
							<el-input :size="$store.state.isphone?'mini':''" v-if="item.type=='string'" v-model="EAform[item.name]" autocomplete="off"></el-input>
							<el-input :size="$store.state.isphone?'mini':''" v-else-if="item.type=='num'" v-model="EAform[item.name]" autocomplete="off"></el-input>
							<my-upload v-else-if="item.type=='image'" v-model="EAform[item.name]"></my-upload>
							<my-uploads v-else-if="item.type=='images'" v-model="EAform[item.name]"></my-uploads>
							<el-input
							  :size="$store.state.isphone?'mini':''"
							  v-else-if="item.type=='text'"
							  type="textarea"
							  :autosize="{ minRows: 2, maxRows: 4}"
							  placeholder="请输入内容"
							  v-model="EAform[item.name]">
							</el-input>
							<my-cascader v-else-if="item.type=='address'" v-model="EAform[item.name]" :placeholder="form.title=='编辑'?'(未修改)':'请选择'" :addlatlng="addlatlng"></my-cascader>
							<my-select v-else-if="item.type=='select'" :show="formOpen" v-model="EAform[item.name]" placeholder="请选择" :data="item.selection.data" type="select" :prop="item.selection.prop"></my-select>
							<my-select v-else-if="item.type=='selects'" :show="formOpen" v-model="EAform[item.name]" placeholder="请选择" :data="item.selection.data" type="selects" :prop="item.selection.prop"></my-select>
							<my-selects v-else-if="item.type=='choose'" :show="formOpen" v-model="EAform[item.name]" :data="item.selection.data" :prop="item.selection.prop"></my-selects>
							<my-date-picker v-else-if="item.type=='date'" v-model="EAform[item.name]" placeholder="选择日期时间"></my-date-picker>
							<my-latlong v-else-if="item.type=='latlong'" v-model="EAform[item.name]"></my-latlong>
							<el-switch :size="$store.state.isphone?'mini':''" v-else-if="item.type=='switch'" v-model="EAform[item.name]" active-color="#13ce66" :active-value="item.selection.switch.open" :inactive-value="item.selection.switch.close"></el-switch>
							<my-file v-else-if="item.type=='file'" v-model="EAform[item.name]"></my-file>
							<my-phone v-else-if="item.type=='phone'" v-model="EAform[item.name]"></my-phone>
							<duration-time v-else-if="item.type=='time'" v-model="EAform[item.name]"></duration-time>
							<div v-else>type参数有误</div>
						</el-form-item>
					</div>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button :size="$store.state.isphone?'mini':'medium'" @click="formOpen = false">取 消</el-button>
					<el-button :size="$store.state.isphone?'mini':'medium'" type="primary" @click="save()">{{form.Bname}}</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="lookOpen" :width="!$store.state.isphone?'900px':($store.state.width-12+'px')">
			<div v-for="(items,index) in fields" :key="index">
				<div class="look-div" v-if="items.limits.look">
					<el-row v-if="items.type=='string'||items.type=='num'||items.type=='phone'">
						<el-col :span="5">
							<div class="look-title">
								{{items.label}}
							</div>
						</el-col>
						<el-col :span="19">
							<div class="look-content">
								{{lookData[items.name]}}
							</div>
						</el-col>
					</el-row>
					<el-row v-if="items.type=='image'">
						<el-col :span="5">
							<div class="look-title">
								{{items.label}}
							</div>
						</el-col>
						<el-col :span="19">
							<div class="look-content">
								<el-image class="look-image" :src="config.apiurl+lookData[items.name]" :preview-src-list="[(config.apiurl+lookData[items.name])]"></el-image>
							</div>
						</el-col>
					</el-row>
					<el-row v-if="items.type=='images'">
						<el-col :span="24">
							<div class="look-title">
								{{items.label}}
							</div>
						</el-col>
						<el-col :span="24">
							<div class="look-content">
								<el-image v-for="item in getimages(lookData[items.name])" :key="item" class="look-image" :src="item" :preview-src-list="getimages(lookData[items.name])"></el-image>
							</div>
						</el-col>
					</el-row>
					<el-row v-if="items.type=='text'">
						<el-col :span="24">
							<div class="look-title">
								{{items.label}}
							</div>
						</el-col>
						<el-col :span="24">
							<div class="look-content">
								{{lookData[items.name]}}
							</div>
						</el-col>
					</el-row>
					<el-row v-if="items.type=='select'">
						<el-col :span="5">
							<div class="look-title">
								{{items.label}}
							</div>
						</el-col>
						<el-col :span="19">
							<div class="look-content">
								{{selectdata[items.name][lookData[items.name]]}}
							</div>
						</el-col>
					</el-row>
					<el-row v-if="items.type=='selects'||items.type=='choose'">
						<el-col :span="5">
							<div class="look-title">
								{{items.label}}
							</div>
						</el-col>
						<el-col :span="19">
							<div class="look-content">
								{{getnames(items,lookData)}}
							</div>
						</el-col>
					</el-row>
					<el-row v-if="items.type=='date'">
						<el-col :span="5">
							<div class="look-title">
								{{items.label}}
							</div>
						</el-col>
						<el-col :span="19">
							<div class="look-content">
								{{Totime(lookData[items.name])}}
							</div>
						</el-col>
					</el-row>
					<el-row v-if="items.type=='latlong'">
						<el-col :span="5">
							<div class="look-title">
								{{items.label}}
							</div>
						</el-col>
						<el-col :span="19">
							<div class="look-content">
								{{lookData[items.name]}}
							</div>
						</el-col>
					</el-row>
					<el-row v-if="items.type=='switch'">
						<el-col :span="5">
							<div class="look-title">
								{{items.label}}
							</div>
						</el-col>
						<el-col :span="19">
							<div class="look-content">
								{{lookData[items.name]==items.selection.switch.open?'已开启':''}}
								{{lookData[items.name]==items.selection.switch.close?'已关闭':''}}
							</div>
						</el-col>
					</el-row>
					<el-row v-if="items.type=='file'">
						<el-col :span="5">
							<div class="look-title">
								{{items.label}}
							</div>
						</el-col>
						<el-col :span="19">
							<div class="look-title">
								<a :href="config.apiurl+lookData[items.name]" class="downfile">点击下载</a>
							</div>
						</el-col>
					</el-row>
					<el-row v-if="items.type=='time'">
						<el-col :span="5">
							<div class="look-title">
								{{items.label}}
							</div>
						</el-col>
						<el-col :span="19">
							<div class="look-title">
								<duration-time v-model="lookData[items.name]" :control="false"></duration-time>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</el-dialog>
		<div class="crud-div">
			<el-row>
				<el-col :span="24" class="sel-div" :style="'height: '+(search?(50*($store.state.isphone?select.length:Math.ceil(select.length/3))+40):0)+'px; margin-bottom: '+(search?15:0)+'px;'">
					<el-col :md="6" v-for="(items,index) in select" :key="index">
						<el-col :span="24" style="margin-bottom: 10px;">
							<el-col :span="6" class="select-label">
								{{items.label}}
							</el-col>
							<el-col :span="18">
								<my-select v-model="selectvalue[items.name]" placeholder="请选择" class="select" :data="items.selection.data" :prop="items.selection.prop"></my-select>
							</el-col>
						</el-col>
					</el-col>
					<el-col :span="24" style="text-align: right;">
						<el-button type="primary" icon="el-icon-search" @click="load()" :size="$store.state.isphone?'mini':'medium'">查询</el-button>
					</el-col>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-button-group style="margin-right: 15px;">
						<el-button v-if="limits.add" type="primary" icon="el-icon-plus" :size="$store.state.isphone?'mini':'medium'" class="add" @click="openAdd()">新增</el-button>
						<el-button type="primary" icon="el-icon-refresh" @click="load()" :size="$store.state.isphone?'mini':'medium'"></el-button>
						<el-button v-if="select.length>0" type="primary" icon="el-icon-search" @click="openSearch()" :size="$store.state.isphone?'mini':'medium'">{{ search?'重置':'高级搜索'}}</el-button>
					</el-button-group>
					<el-button :size="$store.state.isphone?'mini':'medium'" style="float: right;" v-if="limits.export?$store.state.isphone:false" type="primary" icon="el-icon-paperclip" @click="exportExcel()">导出</el-button>
					<!-- <my-select v-for="(items,index) in select" v-model="selectvalue[items.name]" placeholder="请选择" :change="load" class="select" :key="index" :data="items.selection.data" :prop="items.selection.prop"></my-select> -->
					<el-input v-if="limits.find" class="find" v-model="find" placeholder="请输入内容" :size="$store.state.isphone?'mini':'medium'">
						<el-button slot="append" icon="el-icon-search" @click="Find()">搜索</el-button>
					</el-input>
					<el-button :size="$store.state.isphone?'mini':'medium'" style="float: right;" v-if="limits.export?!$store.state.isphone:false" type="primary" icon="el-icon-paperclip" @click="exportExcel()">导出</el-button>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-table id="table" :data="data.list" size="mini" stripe border class="table">
						<el-table-column type="index" width="40"></el-table-column>
						<el-table-column v-for="(item,index) in fields" :key="index" :prop="item.name" :label="item.label" v-if="(item.type=='images'||item.type=='text'||item.type=='address')?false:(item.limits.table?($store.state.isphone?item.limits.phone:true):false)">
							<template slot-scope="scope">
								<el-image v-if="item.type=='image'" style="width: 60px; height: 60px" :src="config.apiurl+scope.row[item.name]" :preview-src-list="[(config.apiurl+scope.row[item.name])]"></el-image>
								<span v-else-if="item.type=='date'">{{Totime(scope.row[item.name])}}</span>
								<el-switch v-else-if="item.type=='switch'" v-model="scope.row[item.name]" active-color="#13ce66" :active-value="item.selection.switch.open" :inactive-value="item.selection.switch.close" :disabled="!item.limits.edit" @change="Switch(scope.row)"></el-switch>
								<span v-else-if="item.type=='select'">{{selectdata[item.name][scope.row[item.name]]}}</span>
								<span v-else-if="item.type=='selects'||item.type=='choose'">{{getnames(item,scope.row)}}</span>
								<span v-else-if="item.type=='file'"><a :href="config.apiurl+scope.row[item.name]" class="downfile">点击下载</a></span>
								<span v-else-if="item.type=='time'"><duration-time v-model="scope.row[item.name]" :control="false"></duration-time></span>
								<span v-else-if="item.name=='amount'">{{ (Number(scope.row[item.name])/100).toFixed(2) + " 元" }}</span>
								<span v-else-if="item.type!='images'">{{scope.row[item.name]}} {{item.unit}}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="80" v-if="limits.look||limits.edit||limits.delete">
							<template slot-scope="scope">
								<el-button type="text" v-if="limits.look&&!limits.edit&&!limits.delete" @click="command({name: 'look', value: scope.row})">查 看</el-button>
								<el-button type="text" v-else-if="!limits.look&&limits.edit&&!limits.delete" @click="command({name: 'edit', value: scope.row})">编 辑</el-button>
								<el-button type="text" v-else-if="!limits.look&&!limits.edit&&limits.delete" @click="command({name: 'del', value: scope.row})">删 除</el-button>
								<el-dropdown v-else @command="command">
									<span class="el-dropdown-link">
										操 作<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item v-if="limits.look" :command="{name: 'look', value: scope.row}">查 看</el-dropdown-item>
										<el-dropdown-item v-if="limits.edit" :command="{name: 'edit', value: scope.row}">编 辑</el-dropdown-item>
										<el-dropdown-item v-if="limits.delete" :command="{name: 'del', value: scope.row}">删 除</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
			<el-row class="pagin">
				<el-col :span="24">
					<div>
						<el-pagination background :small="$store.state.isphone" align="center" @size-change="changeSize" @current-change="nextpage" :current-page="page" :page-sizes="[20, 50, 100, 200]" :page-size="pagesize" :layout="!$store.state.isphone?'total, sizes, prev, pager, next, jumper':'prev, pager, next'" :total="data.page.total"></el-pagination>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import FileSaver from 'file-saver';
	import XLSX from 'xlsx';
	export default {
		data() {
			return {
				formOpen: false,
				lookOpen: false,
				search: false,
				lookData: {},
				find: '',
				selectvalue: this.addselect(),
				selectdata: this.addselectdata(),
				pagesize: 20,
				page: 1,
				data: {
					list: [],
					page: {
						total: 0
					}
				},
				form: {
					title: '添加',
					Bname: '添 加'
				},
				EAform: this.addEAform(),
				EArules: this.addrules(),
				mytime: null
			}
		},
		props: {
			fields: {
				type: Array,
				default: function () {
					return [];
				}
			},
			select: {
				type: Array,
				default: function () {
					return [];
				}
			},
			limits: {
				type: Object,
				default: function () {
					return {
						add: false,
						delete: false,
						edit: false,
						find: false,
						export: false
					};
				}
			},
			apiU: {
				type: String,
				default: ''
			},
			timer: {
				type: Number,
				default: 0
			}
		},
		watch: {
			$route: {
				handler: function(val, oldVal){
					
				}
			}
		},
		beforeDestroy: function () {
　　			clearInterval(this.mytime);
		},
		mounted: function () {
			this.load();
			if(this.timer>0)
			{
				this.mytime=setInterval(this.refresh, this.timer*1000);
			}
		},
		methods: {
			refresh()
			{
				let value={
					keyword: this.find,
					limitPage: this.page,
					limitCount: this.pagesize
				};
				if(this.apiU=="Samplealarmlog"||this.apiU=="Samplelog"||this.apiU=="Disinfectionalarmlog"||this.apiU=="Disinfectionlog"||this.apiU=="Disinfectionpowerlog"||this.apiU=="Alarm"||this.apiU=="Aerationoperate"||this.apiU=="Epc"||this.apiU=="Antenna"||this.apiU=="Label"||this.apiU=="Smslog"||this.apiU=="Tactics")
				{
					value.order="createTime desc"
				}
				for(let key in this.selectvalue)
				{
					value[key]=this.selectvalue[key];
				}
				this.api[this.apiU].getList(value)
				.then((response)=>{
					if(response.data.code==1)
					{
						this.data=response.data.data;
					}
				});
			},
			load()
			{
				this.$store.commit('mainload',true);
				let value={
					keyword: this.find,
					limitPage: this.page,
					limitCount: this.pagesize
				};
				if(this.apiU=="Samplealarmlog"||this.apiU=="Samplelog"||this.apiU=="Disinfectionalarmlog"||this.apiU=="Disinfectionlog"||this.apiU=="Disinfectionpowerlog"||this.apiU=="Alarm"||this.apiU=="Aerationoperate"||this.apiU=="Epc"||this.apiU=="Antenna"||this.apiU=="Label"||this.apiU=="Smslog"||this.apiU=="Tactics")
				{
					value.order="createTime desc"
				}
				for(let key in this.selectvalue)
				{
					value[key]=this.selectvalue[key];
				}
				this.api[this.apiU].getList(value)
				.then((response)=>{
					if(response.data.code==1)
					{
						this.data=response.data.data;
						this.$store.commit('mainload',false);
					}
				});
			},
			changeSize(val) {
				this.pagesize=val;
				this.page=1;
				this.load();
			},
			nextpage(val) {
				this.page=val;
				this.load();
			},
			openEdit(value)
			{
				this.formOpen=true;
				this.$nextTick(()=>{
					this.$refs['EAform'].resetFields();
					this.form.title="编辑";
					this.form.Bname="编 辑";
					this.setdata(this.EAform,value);
					if(this.EAform.address!=null)
					{
						this.EAform.address=this.EAform.address.split('/')[this.EAform.address.split('/').length-1];
					}
				});
			},
			openAdd()
			{
				this.formOpen=true;
				this.$nextTick(()=>{
					this.$refs['EAform'].resetFields();
					this.form.title="添加";
					this.form.Bname="添 加";
				});
			},
			Delete(value)
			{
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(() => {
					this.api[this.apiU].delete({id: value.id})
					.then(() => {
						this.load();
					});
				});
			},
			save()
			{
				this.$refs['EAform'].validate((valid) => {
					if (valid) {
						this.$store.commit('formload',true);
						if(this.form.title=="编辑")
						{
							let editform={};
							for(let i=0;i<this.fields.length;i++)
							{
								if(this.fields[i].limits.edit)
								{
									editform[this.fields[i].name]=this.EAform[this.fields[i].name];
								}
							}
							editform["id"]=this.EAform.id;
							this.api[this.apiU].update(editform)
							.then((response)=>{
								if(response.data.code==1)
								{
									this.formOpen=false;
									this.load();
								}
								this.$store.commit('formload',false);
							});
						}
						else
						{
							let addform={};
							for(let i=0;i<this.fields.length;i++)
							{
								if(this.fields[i].limits.add)
								{
									addform[this.fields[i].name]=this.EAform[this.fields[i].name];
								}
							}
							this.api[this.apiU].add(addform)
							.then((response)=>{
								if(response.data.code==1)
								{
									this.formOpen=false;
									this.load();
								}
								this.$store.commit('formload',false);
							});
						}
					}
				});
			},
			Switch(value)
			{
				this.api[this.apiU].update(value)
				.then((response)=>{
					if(response.data.code!=1)
					{
						this.load();
					}
				});
			},
			Find()
			{
				this.page=1;
				this.load();
			},
			openSearch()
			{
				this.search=!this.search;
				for(let key in this.selectvalue)
				{
					this.selectvalue[key]='';
				}
			},
			addlatlng(adrs)
			{
				let adr = adrs.presentText;
				if(adr==null)
				{
					return;
				}
				// 创建地址解析器实例
				var myGeo = new BMap.Geocoder();
				myGeo.getPoint(adr, (point)=>{
					if (point) {
						if(this.EAform.latLong!=null)
							this.EAform.latLong=point.lat+','+point.lng;
					}else{
						this.message({
							message: "解析错误!",
							type: 'error',
							center: true
						});
					}
				});
			},
			addEAform()
			{
				let forms={};
				forms.id='';
				for(let i=0;i<this.fields.length;i++)
				{
					forms[this.fields[i].name]='';
				}
				return forms;
			},
			addrules()
			{
				let checkNum = (rule, value, callback) => {
					if(Number(value)==0){
						return callback();
					}
					else if (!Number(value)) {
						return callback(new Error('请输入数值'));
					}
					else{
						callback();
					}
				};
				let rules={};
				for(let i=0;i<this.fields.length;i++)
				{
					if(this.fields[i].rule!=null)
					{
						rules[this.fields[i].name]=this.fields[i].rule;
					}
					if(this.fields[i].type=='num')
					{
						if(this.fields[i].rule==null)
						{
							rules[this.fields[i].name]=[];
						}
						rules[this.fields[i].name].push({ validator: checkNum, trigger: 'blur' });
					}
				}
				return rules;
			},
			addselect()
			{
				let selectval={};
				for(let i=0;i<this.select.length;i++)
				{
					selectval[this.select[i].name]='';
				}
				return selectval;
			},
			addselectdata()
			{
				let selectdata={};
				for(let i=0;i<this.fields.length;i++)
				{
					if(this.fields[i].type=="select"||this.fields[i].type=="selects")
					{
						if(this.fields[i].selection.data instanceof Array)
						{
							let sel={};
							for(let j=0;j<this.fields[i].selection.data.length;j++)
							{
								sel[this.fields[i].selection.data[j][this.fields[i].selection.prop.value]]=this.fields[i].selection.data[j][this.fields[i].selection.prop.label];
							}
							selectdata[this.fields[i].name]=sel;
						}
						else if((typeof this.fields[i].selection.data)=='function')
						{
							this.fields[i].selection.data()
							.then((res)=>{
								let sel={};
								for(let j=0;j<res.data.data.list.length;j++)
								{
									sel[res.data.data.list[j][this.fields[i].selection.prop.value]]=res.data.data.list[j][this.fields[i].selection.prop.label];
								}
								this.selectdata[this.fields[i].name]=sel;
							});
							selectdata[this.fields[i].name]=[];
						}
					}
				}
				return selectdata;
			},
			getnames(item,value)
			{
				let type='';
				if(value[item.name]==null)
				{
					return '';
				}
				let val=value[item.name].toString().split(',');
				if(val.length>0)
				{
					type=this.selectdata[item.name][val[0]];
				}
				for(let i=1;i<val.length;i++)
				{
					type=type+' & '+this.selectdata[item.name][val[i]];
				}
				return type;
			},
			getimages(images)
			{
				if(images==null)
				{
					return;
				}
				return images.split(',').map((value)=>{
					return this.config.apiurl+value;
				});
			},
			command(command)
			{
				if(command.name=="look")
				{
					this.lookData=command.value;
					this.lookOpen=true;
				}
				else if(command.name=="edit")
				{
					this.openEdit(command.value);
				}
				else if(command.name=="del")
				{
					this.Delete(command.value);
				}
			},
			exportExcel() {
				/* npm install --save xlsx file-saver 需要获取依赖 */
				var wb = XLSX.utils.table_to_book(document.querySelector('.table'))
				/* get binary string as output */
				var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
				try {
					FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
				} catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
				this.message({message: '导出成功！',type: 'success'});
				return wbout
			}
		}
	}
</script>

<style scoped>
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.output{
		text-align: right;
	}
	.table{
		margin-top: 15px;
		width: 100%;
	}
	.add{
		
	}
	.pagin{
		margin-top: 10px;
	}
	.fm-img{
		width: 100px;
		height: 100px;
		border: 1px solid #d9d9d9;
		border-radius: 6px;
	}
	.border{
		border: 1px solid #dcdfe6;
		border-radius:4px;
	}
	.slot_table{
		border: 1px solid #EBEEF5;
		border-collapse: collapse ;
	}
	.slot_table>.el-form-item {
		margin-bottom: 0px;
		color: #1991FA;
	}
	.slot_form{
		width: 70%;
		margin: 0 auto;
	}
	.lable_name{
		vertical-align: middle;
		float: left;
		font-size: 14px;
		color: #606266;
		line-height: 40px;
		padding: 0 12px 0 0;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 30%;
		padding-left: 0.75rem;
		/* border-right: 1px solid #EBEEF5; */
	}
	.lable_value{
		float: left;
		line-height: 40px;
		font-size: 14px;
		color: #1991FA;
		width: 70%;
		text-align: center;
	}
	.dialog-footer{
		text-align: center;
	}
	.find{
		width: 300px;
		top: -1px;
	}
	.select-label{
		line-height: 40px;
		text-align: center;
		color: #606266;
	}
	.select{
		/* width: 100px !important; */
		bottom: -1px;
		/* margin-right: 15px; */
	}
	.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}
	.el-icon-arrow-down {
		font-size: 12px;
	}
	.downfile{
		text-decoration: none;
		color: #409eff;
	}
	.look-div{
		font-size: 16px;
	}
	.look-content{
		border: 1px solid #DCDFE6;
		padding: 5px;
		margin: 5px 0;
		border-radius: 4px;
		min-height: 23px;
		max-height: 230px;
		overflow: auto;
	}
	.look-title{
		line-height: 45px;
	}
	.look-image{
		width: 120px;
		height: 120px;
		margin-right: 5px;
		border: 1px solid #E4E7ED;
		border-radius: 4px;
	}
	.sel-div{
		transition: height 0.5s;
		/* border-radius: 3px; */
		/* box-shadow: 1px 1px 3px #333 inset; */
		/* height: 100px; */
		background-color: white;
		overflow: hidden;
		/* padding: 3px; */
	}
	.crud-div{
		background-color: #fff;
		border-radius: 3px;
		padding: 5px;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.slot_form{
			width: 100%;
		}
		.table{
			margin-top: 5px;
		}
		.find{
			width: 100%;
			margin-left: 0px;
			margin-top: 5px;
		}
		.select-label{
			font-size: 14px;
		}
		.select{
			width: 100% !important;
			margin-left: 0px;
			margin-top: 5px;
		}
		.el-form-item {
			margin-bottom: 0px;
		}
	}
</style>